import type { LocaleBundle } from '../types.js'

export const de: LocaleBundle = {
  code: 'de',
  name: 'Deutsch',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Startseite',
    'common:search': 'Suche',
    'common:loading': 'Lädt…',
    'common:save': 'Speichern',
    'common:cancel': 'Abbrechen',
    'common:delete': 'Löschen',
    'common:create': 'Erstellen',
    'common:edit': 'Bearbeiten',
    'common:show': 'Anzeigen',
    'common:back': 'Zurück',
    'common:noRecords': 'Keine Einträge gefunden.',
    'common:noRecordsHint': 'Erstellen Sie einen neuen Eintrag „{resource}", um zu beginnen.',
    'common:noMatchingRecords': 'Keine Einträge entsprechen Ihren Filtern.',
    'common:clearFilters': 'Filter zurücksetzen',
    'common:confirmDelete': 'Diesen Eintrag löschen?',
    'common:confirmAction': 'Aktion bestätigen',
    'common:confirm': 'Bestätigen',
    'common:perPage': 'Pro Seite',
    'common:page': 'Seite',
    'common:of': 'von',
    'common:total': 'Gesamt',
    'auth:login': 'Anmelden',
    'auth:logout': 'Abmelden',
    'auth:email': 'E-Mail',
    'auth:password': 'Passwort',
    'auth:loginFailed': 'Ungültige Zugangsdaten.',
    'errors:notFound': 'Nicht gefunden.',
    'errors:forbidden': 'Kein Zugriff auf diese Ressource.',
    'errors:server': 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    'common:resources': 'Ressourcen',
    'common:actions': 'Aktionen',
    'action:notFound': 'Aktion „{action}“ ist für diese Ressource nicht verfügbar.',
    'action:componentMissing': 'Es ist keine Komponente namens „{component}“ registriert.',
    'action:componentMissingHint': 'Registriere sie im ComponentLoader, der an <ModernAdminProvider components={…}> übergeben wird.',
    'action:loadFailed': 'Die Aktion konnte nicht geladen werden.',
    'common:new': 'Neu',
    'common:rowsPerPage': 'Zeilen pro Seite',
    'common:filter': 'Filter {label}…',
    'validation:required': '{label} ist erforderlich',
    'validation:invalidNumber': '{label} muss eine gültige Zahl sein',
    'validation:invalidInteger': '{label} muss eine ganze Zahl sein',
    'validation:invalidEmail': '{label} muss eine gültige E-Mail sein',
    'validation:invalidUrl': '{label} muss eine gültige URL sein',
    'validation:invalidDate': '{label} muss ein gültiges Datum sein',
    'validation:invalidUuid': '{label} muss eine gültige UUID sein',
    'validation:tooShort': '{label} muss mindestens {min} Zeichen lang sein',
    'validation:tooLong': '{label} darf höchstens {max} Zeichen lang sein',
    'validation:notInList': '{label} hat einen ungültigen Wert',
    'validation:emptySelection': 'Bitte mindestens einen Wert für {label} wählen',
    'toast:created': 'Erfolgreich erstellt',
    'toast:saved': 'Erfolgreich gespeichert',
    'toast:deleted': 'Erfolgreich gelöscht',
    'toast:createFailed': 'Erstellen fehlgeschlagen',
    'toast:saveFailed': 'Speichern fehlgeschlagen',
    'toast:deleteFailed': 'Löschen fehlgeschlagen',
    'toast:loadFailed': 'Laden fehlgeschlagen',
    'toast:validationFailed': 'Bitte Fehler beheben und erneut versuchen',
    'common:close': 'Schließen',
    'common:export': 'Export',
    'export:title': 'Datensätze exportieren',
    'export:description': 'Alle passenden Datensätze von {resource} als Datei herunterladen.',
    'export:csvHint': 'Kommagetrennte Werte',
    'export:jsonHint': 'Strukturiertes JSON-Array',
    'export:downloading': 'Download wird vorbereitet…',
    'export:progress': '{loaded} von {total} geladen…',
    'export:exported': '{count} Datensätze exportiert',
    'export:exportFailed': 'Export fehlgeschlagen',
    'common:apply': 'Anwenden',
    'common:clear': 'Zurücksetzen',
    'common:filters': 'Filter',
    'common:columns': 'Spalten',
    'common:toggleColumns': 'Spalten anzeigen',
    'common:openMenu': 'Menü öffnen',
    'common:refresh': 'Aktualisieren',
    'common:copy': 'Kopieren',
    'common:copied': 'Kopiert!',
    'common:applyFilters': 'Filter anwenden',
    'common:clearAll': 'Alle löschen',
    'common:any': 'Beliebig',
    'common:yes': 'Ja',
    'common:no': 'Nein',
    'common:filterPlaceholder': 'Filter…',
    'common:loadFailed': 'Laden fehlgeschlagen: {error}',
    'common:theme': 'Design',
    'common:language': 'Sprache',
    'common:toggleTheme': 'Design umschalten',
    'common:clearSelection': 'Auswahl löschen',
    'common:searchPlaceholder': 'Suchen…',
    'home:searchResources': 'Ressourcen suchen…',
    'home:noMatchingResources': 'Keine passenden Ressourcen gefunden.',
    'globalSearch:title': 'Globale Suche',
    'globalSearch:description': 'Über alle Ressourcen und Datensätze hinweg suchen.',
    'globalSearch:trigger': 'Suchen…',
    'globalSearch:placeholder': 'Über alle Ressourcen suchen…',
    'globalSearch:hint': 'Tippen, um in allen Ressourcen zu suchen.',
    'globalSearch:noResults': 'Keine passenden Datensätze gefunden.',
    'globalSearch:error': 'Suche fehlgeschlagen. Bitte erneut versuchen.',
    'globalSearch:hotkey': 'Globale Suche öffnen',
    'globalSearch:matchedIn': 'in {field}',
    'globalSearch:recent': 'Letzte Suchen',
    'globalSearch:clearRecent': 'Löschen',
    'globalSearch:showAllIn': 'Alle in {resource} anzeigen',
    'common:pageOf': 'Seite {page} von {total}',
    'common:firstPage': 'Erste Seite',
    'common:previousPage': 'Vorherige Seite',
    'common:nextPage': 'Nächste Seite',
    'common:lastPage': 'Letzte Seite',
    'common:recordsCount': '{count} Einträge',
    'common:selectedCount': '{count} ausgewählt',
    'common:selectRow': 'Zeile auswählen',
    'common:selectAll': 'Alle auswählen',
    'common:deleteSelected': 'Ausgewählte löschen',
    'common:bulkDeleteConfirm': '{count} ausgewählte Datensätze löschen?',
    'toast:bulkDeleted': '{count} Datensätze gelöscht',
    'toast:bulkDeleteFailed': 'Datensätze konnten nicht gelöscht werden',
    'common:from': 'Von',
    'common:to': 'Bis',
    'common:sortBy': 'Sortieren nach',
    'common:next': 'Weiter',
    'common:previous': 'Zurück',
    'common:relatedRecords': 'Verknüpfte Datensätze',
    'common:viewAll': 'Alle anzeigen',
    'common:noRelatedRecords': 'Keine verknüpften Datensätze.',
    'common:preview': 'Vorschau',
    'common:download': 'Herunterladen',
    'common:openInNewTab': 'In neuem Tab öffnen',
    'common:format': 'Formatieren',
    'common:invalidJson': 'Ungültiges JSON',
    'common:showPassword': 'Passwort anzeigen',
    'common:hidePassword': 'Passwort verbergen',
    'common:shortcutsHelp': 'Tastenkürzel',
    'common:shortcutsEmpty': 'Auf diesem Bildschirm sind keine Kürzel verfügbar.',
    'auth:title': 'Anmelden',
    'auth:subtitle': 'Geben Sie Ihre E-Mail und Ihr Passwort ein',
    'auth:tagline': 'Das moderne Admin-Panel für jeden Stack.',
    'auth:orContinueWith': 'Oder weiter mit',
    'auth:continueWith': 'Weiter mit {provider}',
    'common:chooseFile': 'Datei auswählen',
    'common:chooseFiles': 'Dateien auswählen',
    'common:dragAndDrop': 'Ziehen und ablegen oder',
    'common:chooseAFile': 'Datei auswählen',
    'common:addMoreFiles': 'weitere Dateien hinzufügen',
    'common:uploading': 'Wird hochgeladen…',
    'common:uploadingFile': '„{name}" wird hochgeladen…',
    'common:removeFile': 'Datei entfernen',
    'common:uploadFailed': 'Upload fehlgeschlagen',
    'common:dismiss': 'Schließen',
    'common:openCalendar': 'Kalender öffnen',
    'common:time': 'Uhrzeit',
    'common:downloadFailed': 'Download fehlgeschlagen',
    'richtext:bold': 'Fett',
    'richtext:italic': 'Kursiv',
    'richtext:strikethrough': 'Durchgestrichen',
    'richtext:inlineCode': 'Inline-Code',
    'richtext:heading': 'Überschrift {level}',
    'richtext:bulletList': 'Aufzählungsliste',
    'richtext:numberedList': 'Nummerierte Liste',
    'richtext:blockquote': 'Blockzitat',
    'richtext:horizontalRule': 'Horizontale Linie',
    'richtext:insertLink': 'Link einfügen',
    'richtext:undo': 'Rückgängig',
    'richtext:redo': 'Wiederholen',
    'richtext:source': 'Quelltext ({format})',
    'richtext:splitView': 'Geteilte Ansicht',
    'richtext:visualEditor': 'Visueller Editor',
    'richtext:fullscreen': 'Vollbild',
    'richtext:exitFullscreen': 'Vollbild beenden',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Speichern…',
    'common:done': 'Fertig',
    'settings:menuItem': 'Einstellungen',
    'settings:noSectionsConfigured': 'Für diese Installation sind keine Einstellungsbereiche verfügbar.',
    'settings:apiKeys.title': 'API-Schlüssel',
    'settings:apiKeys.description': 'Programmatische Zugriffstoken für die Admin-API. Jeder Schlüssel hat eine Berechtigungsmenge, die einschränkt, welche Ressourcen und Aktionen er ausführen darf.',
    'settings:apiKeys.actions.create': 'Neuer Schlüssel',
    'settings:apiKeys.actions.edit': 'Bearbeiten',
    'settings:apiKeys.actions.revoke': 'Widerrufen',
    'settings:apiKeys.empty.title': 'Noch keine API-Schlüssel',
    'settings:apiKeys.empty.description': 'Erstelle deinen ersten Schlüssel für programmatischen Zugriff.',
    'settings:apiKeys.columns.name': 'Name',
    'settings:apiKeys.columns.start': 'Präfix',
    'settings:apiKeys.columns.permissions': 'Berechtigungen',
    'settings:apiKeys.columns.expiresAt': 'Läuft ab',
    'settings:apiKeys.columns.enabled': 'Aktiviert',
    'settings:apiKeys.columns.actions': 'Aktionen',
    'settings:apiKeys.lastUsed': 'Zuletzt verwendet {date}',
    'settings:apiKeys.expiresNever': 'Nie',
    'settings:apiKeys.permissions.resource': 'Ressource',
    'settings:apiKeys.permissions.actions': 'Aktionen',
    'settings:apiKeys.permissions.selectAll': 'Alle auswählen',
    'settings:apiKeys.permissions.clearAll': 'Alle entfernen',
    'settings:apiKeys.permissions.none': 'Keine Berechtigungen',
    'settings:apiKeys.permissions.summary': '{resources} Ressourcen · {actions} Aktionen',
    'settings:apiKeys.permissions.noResources': 'Es sind keine Ressourcen registriert.',
    'settings:apiKeys.permissions.selectAllResources': 'Alle Ressourcen und Aktionen auswählen',
    'settings:apiKeys.permissions.clearAllResources': 'Alle Ressourcen und Aktionen entfernen',
    'settings:apiKeys.editor.titleCreate': 'Neuer API-Schlüssel',
    'settings:apiKeys.editor.titleEdit': 'API-Schlüssel bearbeiten',
    'settings:apiKeys.editor.description': 'Wähle einen aussagekräftigen Namen und gewähre nur die Ressourcen und Aktionen, die der Schlüssel wirklich braucht.',
    'settings:apiKeys.editor.name': 'Name',
    'settings:apiKeys.editor.namePlaceholder': 'z. B. CI-Deploy-Bot',
    'settings:apiKeys.editor.expiresInDays': 'Läuft ab in (Tagen)',
    'settings:apiKeys.editor.expiresPlaceholder': 'nie',
    'settings:apiKeys.editor.expiresHint': 'Leer lassen, damit der Schlüssel nicht abläuft. Maximal 3650 Tage.',
    'settings:apiKeys.editor.permissions': 'Berechtigungen',
    'settings:apiKeys.editor.selectedActions': '{count} ausgewählt',
    'settings:apiKeys.created.title': 'API-Schlüssel erstellt',
    'settings:apiKeys.created.description': 'Kopiere den Schlüssel jetzt — er wird nicht erneut angezeigt.',
    'settings:apiKeys.created.warning': 'Dies ist die einzige Gelegenheit, den vollständigen Schlüssel zu sehen. Bewahre ihn sicher auf.',
    'settings:apiKeys.created.reveal': 'Schlüssel anzeigen',
    'settings:apiKeys.created.hide': 'Schlüssel ausblenden',
    'settings:apiKeys.created.copy': 'Kopieren',
    'settings:apiKeys.created.copied': 'Kopiert',
    'settings:apiKeys.notice.revoked': 'API-Schlüssel widerrufen',
    'settings:apiKeys.notice.updated': 'API-Schlüssel aktualisiert',
    'settings:apiKeys.notice.copied': 'In die Zwischenablage kopiert',
    'settings:apiKeys.notice.copyFailed': 'Kopieren in die Zwischenablage fehlgeschlagen',
    'settings:apiKeys.confirmRevoke.title': 'API-Schlüssel widerrufen',
    'settings:apiKeys.confirmRevoke.description': '„{name}" widerrufen? Alle Dienste, die diesen Schlüssel verwenden, funktionieren sofort nicht mehr.',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'Dashboard',
    'chart:addChart': 'Diagramm hinzufügen',
    'chart:newChart': 'Neues Diagramm',
    'chart:editChart': 'Diagramm bearbeiten',
    'chart:deleteChart': 'Diagramm entfernen',
    'chart:noCharts': 'Keine Diagramme vorhanden',
    'chart:noChartsHint': 'Fügen Sie ein Diagramm hinzu, um Ihre Daten zu überwachen.',
    'chart:addGroup': 'Gruppe hinzufügen',
    'chart:newGroup': 'Neue Gruppe',
    'chart:editGroup': 'Gruppe bearbeiten',
    'chart:deleteGroup': 'Gruppe entfernen',
    'chart:saveGroup': 'Gruppe speichern',
    'chart:groupName': 'Gruppenname',
    'chart:groupNamePlaceholder': 'z. B. Verkaufsmetriken',
    'chart:groupNameRequired': 'Gruppenname ist erforderlich',
    'chart:groupOrder': 'Reihenfolge der Gruppe',
    'chart:order': 'Reihenfolge',
    'chart:orderHint': 'Niedrigere Zahlen erscheinen zuerst.',
    'chart:moveToGroup': 'In Gruppe verschieben',
    'chart:moveChart': 'Diagramm verschieben',
    'chart:moveGroup': 'Gruppe',
    'chart:moveNoGroups': 'Noch keine Gruppen.',
    'chart:moveNoGroupsHint': 'Erstellen Sie zuerst eine Gruppe, um Diagramme zu organisieren.',
    'chart:deleteChartConfirm': 'Diagramm entfernen?',
    'chart:deleteChartConfirmHint': 'Diese Aktion kann nicht rückgängig gemacht werden.',
    'chart:deleteGroupConfirm': 'Diese Gruppe entfernen?',
    'chart:deleteGroupConfirmHint': 'Die Gruppe und alle darin enthaltenen Diagramme ({count}) werden dauerhaft gelöscht.',
    'chart:title': 'Titel',
    'chart:titlePlaceholder': 'z.B. Neue Nutzer pro Tag',
    'chart:untitled': 'Ohne Titel',
    'chart:chartType': 'Diagrammtyp',
    'chart:resource': 'Ressource',
    'chart:groupBy': 'Gruppieren nach',
    'chart:step': 'Schritt',
    'chart:metric': 'Metrik',
    'chart:aggregateField': 'Aggregationsfeld',
    'chart:selectField': 'Feld auswählen…',
    'chart:saveChart': 'Diagramm speichern',
    'chart:typeLine': 'Linie',
    'chart:typeArea': 'Fläche',
    'chart:typeBar': 'Balken',
    'chart:typePie': 'Kreis',
    'chart:stepDay': 'Tag',
    'chart:stepWeek': 'Woche',
    'chart:stepMonth': 'Monat',
    'chart:stepYear': 'Jahr',
    'chart:metricCount': 'Anzahl',
    'chart:metricSum': 'Summe',
    'chart:metricAvg': 'Durchschnitt',
    'chart:noData': 'Keine Daten für den ausgewählten Zeitraum',
    'chart:loadError': 'Diagrammdaten konnten nicht geladen werden',
    'chart:value': 'Wert',
    'dashboard:vis': 'Visualisierung',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Linie',
    'dashboard:visArea': 'Fläche',
    'dashboard:visBar': 'Balken',
    'dashboard:visPie': 'Kreis',
    'dashboard:metricCount': 'Anzahl',
    'dashboard:metricSum': 'Summe',
    'dashboard:metricAvg': 'Durchschnitt',
    'dashboard:metricMin': 'Min',
    'dashboard:metricMax': 'Max',
    'dashboard:builder.range': 'Zeitraum',
    'dashboard:builder.filters': 'Filter',
    'dashboard:builder.filtersHint': 'Datensatz vor der Aggregation eingrenzen. Aktiviere ein Häkchen, um den Filter über dem Diagramm einzublenden.',
    'dashboard:builder.quickFilterHint': 'Diesen Filter über dem Diagramm im Dashboard anzeigen.',
    'dashboard:builder.quickFilterToggle': '{field} als Schnellfilter einblenden',
    'dashboard:range.7d': '7T',
    'dashboard:range.30d': '30T',
    'dashboard:range.90d': '90T',
    'dashboard:range.1y': '1J',
    'dashboard:range.all': 'Alle',
    'dashboard:range.custom': 'Benutzerdefiniert',
    'dashboard:widget.previousPeriod': 'ggü. Vorperiode',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Auf halbe Breite verkleinern',
    'dashboard:widget.expand': 'Auf volle Zeile erweitern',
    'dashboard:widget.toggleSql': 'SQL anzeigen',
    'dashboard:widget.unsupported': 'Diagramme werden für Ihre Datenbank noch nicht unterstützt.',
    'dashboard:widget.truncatedWarning': 'Teildaten werden angezeigt – zu viele Zeilen, um den gesamten Bereich zu aggregieren.',
    'dashboard:widget.showAll': 'Alle anzeigen',
    'dashboard:widget.hideAll': 'Alle ausblenden',
    'dashboard:seriesTotal': 'Gesamt',
    'dashboard:seriesOther': 'Sonstige',
    'dashboard:seriesNull': 'Leer',
    'dashboard:builder.dateField': 'Datumsfeld',
    'dashboard:builder.dateFieldHint': 'Die X-Achse wird nach diesem Datumsfeld gruppiert.',
    'dashboard:builder.secondaryGroupBy': 'Aufschlüsselung',
    'dashboard:builder.noBreakdown': 'Einzelne Reihe',
    'dashboard:builder.topN': 'Max. Reihen',
    'dashboard:builder.width': 'Breite',
    'dashboard:width.half': 'Halb',
    'dashboard:width.full': 'Volle Zeile',
    'dashboard:builder.comparePrevious': 'Mit vorherigem Zeitraum vergleichen',
    'dashboard:builder.comparePreviousHint': 'Blendet den gleich langen vorherigen Zeitraum als gestrichelte Linie ein und zeigt die Veränderung neben dem Titel an.',
    'dashboard:builder.comparePreviousDisabled': 'Bei einer Aufschlüsselung nicht verfügbar.',
    'dashboard:builder.transform': 'Wertetransformation',
    'dashboard:builder.transformHint': 'Wird vor der Anzeige auf die Werte angewendet — z. B. durch 100 teilen, um Cent als Euro anzuzeigen.',
    'dashboard:builder.transformAdd': 'Schritt hinzufügen',
    'dashboard:builder.transformRemove': 'Schritt entfernen',
    'dashboard:builder.opDivide': 'Dividieren durch',
    'dashboard:builder.opMultiply': 'Multiplizieren mit',
    'dashboard:builder.opAdd': 'Addieren',
    'dashboard:builder.opSubtract': 'Subtrahieren',
    'dashboard:builder.format': 'Werteformat',
    'dashboard:builder.formatStyle': 'Stil',
    'dashboard:builder.formatNumber': 'Zahl',
    'dashboard:builder.formatCurrency': 'Währung',
    'dashboard:builder.formatPercent': 'Prozent',
    'dashboard:builder.formatCurrencyCode': 'Währungscode',
    'dashboard:builder.formatDecimals': 'Dezimalstellen',
    'dashboard:builder.formatCompact': 'Kompakte Zahlen (12,5 Tsd.)',
    'dashboard:builder.formatPrefix': 'Präfix',
    'dashboard:builder.formatSuffix': 'Suffix',
    'dashboard:builder.color': 'Reihenfarbe',
    'dashboard:widget.previousSeries': '{label} (Vorperiode)',
    'dashboard:widget.editColors': 'Farben bearbeiten',
    'dashboard:widget.colorsTitle': 'Reihenfarben',
    'dashboard:widget.colorCustom': 'Benutzerdefiniert',
    'dashboard:widget.colorAuto': 'Automatisch',
    'dashboard:widget.colorPick': 'Farbe wählen',
    'dashboard:builder.tabData': 'Daten',
    'dashboard:builder.tabDisplay': 'Darstellung',
    'dashboard:builder.tabFilters': 'Filter',
    'dashboard:builder.filtersEmpty': 'Diese Ressource hat keine filterbaren Felder.',
    'history:revisions': 'Revisionen',
    'history:noRevisions': 'Noch keine Revisionen',
    'history:loadError': 'Revisionsverlauf konnte nicht geladen werden',
    'history:revert': 'Zurücksetzen',
    'history:confirmRevert': 'Zu dieser Revision zurücksetzen?',
    'history:revertSuccess': 'Revision wiederhergestellt',
    'history:revertFailed': 'Revision konnte nicht wiederhergestellt werden',
    'history:unknownUser': 'Unbekannter Benutzer',
    'history:changes': 'Änderungen',
    'history:compareTo': 'Vergleichen mit',
    'history:storedDiff': 'Änderungsdiff',
    'history:op.create': 'Erstellt',
    'history:op.update': 'Aktualisiert',
    'history:op.delete': 'Gelöscht',
    'diff:added': 'Hinzugefügt',
    'diff:changed': 'Geändert',
    'diff:removed': 'Entfernt',
    'diff:before': 'Vorher',
    'diff:after': 'Nachher',
    'diff:noChanges': 'Keine Feldänderungen aufgezeichnet',
    'audit:title': 'Aktivität',
    'audit:resource': 'Ressource',
    'audit:action': 'Aktion',
    'audit:recordId': 'Datensatz-ID',
    'audit:userId': 'Benutzer-ID',
    'audit:allResources': 'Alle Ressourcen',
    'audit:allActions': 'Alle Aktionen',
    'audit:noEvents': 'Noch keine Aktivität',
    'audit:records': 'Datensätze',
    'audit:loadError': 'Aktivität konnte nicht geladen werden',
    'audit:by': 'von {user}',
    'audit:viewRecord': 'Datensatz öffnen',
    'audit:viewChanges': 'Änderungen anzeigen',
    'audit:hideChanges': 'Änderungen ausblenden',
    'audit:noDiff': 'Details zu den Änderungen sind nicht verfügbar',
    'audit:loadDiffError': 'Änderungen konnten nicht geladen werden',
    'audit:action.new': 'Datensatz erstellt',
    'audit:action.edit': 'Datensatz aktualisiert',
    'audit:action.delete': 'Datensatz gelöscht',
    'audit:action.bulkDelete': 'Datensätze gelöscht',
    'audit:action.login': 'Angemeldet',
    'audit:action.apiKeyCreate': 'API-Schlüssel erstellt',
    'audit:action.apiKeyUpdate': 'API-Schlüssel aktualisiert',
    'audit:action.apiKeyDelete': 'API-Schlüssel gelöscht',
    'audit:virtualResource.auth': 'Authentifizierung',
    'audit:virtualResource.apiKeys': 'API-Schlüssel',
    'audit:prevPage': 'Zurück',
    'audit:nextPage': 'Weiter',
    'audit:dateRangePlaceholder': 'Datumsbereich auswählen',
    'keyValue:noMatches': 'Keine Treffer – Enter drücken, um „{value}" zu übernehmen.',
    'aiAssistant:queue.cancel': 'Aus Warteschlange entfernen',
    'aiAssistant:title': 'KI-Assistent',
    'aiAssistant:fab.label': 'KI-Assistenten öffnen',
    'aiAssistant:fab.short': 'KI',
    'aiAssistant:description': 'Stellen Sie Fragen zu Datensätzen, Beziehungen, Berichten und Datentrends.',
    'aiAssistant:notConfigured.title': 'Assistent ist nicht konfiguriert',
    'aiAssistant:notConfigured.description': 'Fügen Sie den OpenRouter-API-Schlüssel in den Einstellungen hinzu, um den schreibgeschützten KI-Assistenten zu aktivieren.',
    'aiAssistant:notConfigured.openSettings': 'Einstellungen öffnen',
    'aiAssistant:tryAsking': 'Versuchen Sie zu fragen:',
    'aiAssistant:tryAsking.example1': 'Welche Kunden haben die meisten Beiträge?',
    'aiAssistant:tryAsking.example2': 'Zeige kürzlich erstellte Datensätze einer Ressource.',
    'aiAssistant:tryAsking.example3': 'Erkläre Beziehungen zwischen bestimmten Datensätzen.',
    'aiAssistant:thinking': 'Denke nach',
    'aiAssistant:thinkingProgress': 'Denke nach ({progress}%)',
    'aiAssistant:input.placeholder': 'Fragen Sie zu Ihren Daten…',
    'aiAssistant:input.hint': 'Enter zum Senden · Shift+Enter für eine neue Zeile',
    'aiAssistant:send': 'Nachricht senden',
    'aiAssistant:newChat': 'Neuer Chat',
    'aiAssistant:history': 'Chatverlauf',
    'aiAssistant:history.empty': 'Keine früheren Chats',
    'aiAssistant:noText': 'Hier sind die gefundenen zugehörigen Datensätze:',
    'aiAssistant:fallback.noToolResult': 'Die Anfrage wurde ausgeführt, aber das Modell hat keine Textantwort zurückgegeben. Präzisieren Sie die Frage oder aktivieren Sie Debug-Logs, um das Tool-Ergebnis zu prüfen.',
    'aiAssistant:fallback.noRows': 'Für diese Anfrage wurden keine Datensätze gefunden.',
    'aiAssistant:fallback.rowsFound': 'Gefundene Zeilen: {count}.',
    'aiAssistant:taskFailed': 'KI-Assistent-Aufgabe fehlgeschlagen',
    'aiAssistant:settings.title': 'KI-Assistent',
    'aiAssistant:settings.description': 'Konfigurieren Sie das schwebende Chat-Widget, das Modell und das serverseitige Assistentenverhalten.',
    'aiAssistant:settings.enabled': 'Aktiviert',
    'aiAssistant:settings.disabled': 'Deaktiviert',
    'aiAssistant:settings.configured': 'Konfiguriert',
    'aiAssistant:settings.apiKeyRequired': 'API-Schlüssel erforderlich',
    'aiAssistant:settings.readOnly': 'Nur lesen',
    'aiAssistant:settings.provider': 'Anbieter: {provider}',
    'aiAssistant:settings.enableLabel': 'Assistenten aktivieren',
    'aiAssistant:settings.enableHint': 'Steuert die Sichtbarkeit des schwebenden Widgets und des Chat-Endpunkts.',
    'aiAssistant:settings.modelLabel': 'OpenRouter-Modell',
    'aiAssistant:settings.apiKeyLabel': 'OpenRouter-API-Schlüssel',
    'aiAssistant:settings.apiKeyHint': 'Leer lassen, um den auf dem Server gespeicherten Schlüssel beizubehalten.',
    'aiAssistant:settings.systemPromptLabel': 'System-Prompt überschreiben',
    'aiAssistant:settings.systemPromptPlaceholder': 'Optionale projektspezifische Anweisungen für den Assistenten',
    'aiAssistant:settings.accessTitle': 'Zugriffsmodell',
    'aiAssistant:settings.accessDescription': 'Der aktuelle Assistent ist auf schreibgeschützte Datensatzprüfung über Admin-Ressourcenaktionen beschränkt.',
    'aiAssistant:settings.futureToolsReady': 'Bereit für zukünftige Tools',
    'aiAssistant:settings.save': 'Einstellungen speichern',
    'aiAssistant:settings.saving': 'Speichere…',
    'aiAssistant:settings.saved': 'KI-Assistent-Einstellungen gespeichert',
    'aiAssistant:settings.empty': 'Keine Einstellungen verfügbar.',
    'filter:op.co': 'Enthält',
    'filter:op.nco': 'Enthält nicht',
    'filter:op.sw': 'Beginnt mit',
    'filter:op.ew': 'Endet mit',
    'filter:op.eq': 'Ist gleich',
    'filter:op.neq': 'Ist nicht gleich',
    'filter:op.empty': 'Ist leer',
    'filter:op.nempty': 'Ist nicht leer',
    'filter:op.in': 'Ist einer von',
    'filter:op.gt': 'Größer als',
    'filter:op.lt': 'Kleiner als',
    'filter:op.between': 'Zwischen',
    'filter:searchValues': 'In Liste suchen…',
    'filter:selectAll': 'Alle auswählen',
    'filter:noValues': 'Keine Werte gefunden',
    'common:newRecord': 'Neu: {name}',
    'common:editRecord': '{name} #{id} bearbeiten',
    'common:themeLight': 'Hell',
    'common:themeDark': 'Dunkel',
    'common:themeSystem': 'System',
    'common:ok': 'OK',
    'common:select': 'Auswählen…',
    'common:removeItem': '{title} entfernen',
    'common:nSelectedAddMore': '{count} ausgewählt — weitere hinzufügen',
    'common:pickRecords': 'Datensätze auswählen',
    'common:managePickRecords': 'Auswahl verwalten ({count})',
    'common:pickRecordsFrom': 'Aus {name} auswählen',
    'common:draftRestored': 'Nicht gespeicherter Entwurf wiederhergestellt',
    'common:undoDraftRestore': 'Rückgängig',
    'aiFill:button': 'KI-Ausfüllen',
    'aiFill:dialogTitle': 'Formular aus Foto ausfüllen',
    'aiFill:dialogDescription': 'Bild hochladen — die KI extrahiert die Werte und füllt das Formular aus.',
    'aiFill:fillButton': 'Erkennen',
    'aiFill:processing': 'Bild wird erkannt…',
    'aiFill:success': '{count} Feld(er) ausgefüllt',
    'aiFill:errorNoFields': 'Diese Ressource hat keine KI-ausfüllbaren Felder.',
    'aiFill:errorGeneric': 'KI-Ausfüllen fehlgeschlagen: {message}',
    'aiFill:noValues': 'Die KI konnte aus diesem Bild keine Werte extrahieren.',
    'aiFill:applied': 'KI hat {count} Feld(er) ausgefüllt. Unten rückgängig machen.',
    'wizard:stepOf': 'Schritt {current} von {total}',
    'wizard:products.step1': 'Grundinfo',
    'wizard:products.step2': 'Preisgestaltung',
    'wizard:products.step3': 'Medien & Tags',
    'common:invalidValue': 'Ungültiger Wert',
    'common:collapseSidebar': 'Seitenleiste einklappen',
    'common:expandSidebar': 'Seitenleiste ausklappen',
    'common:toggleSidebar': 'Seitenleiste umschalten',
    'common:sidebarTitle': 'Seitenleiste',
    'common:sidebarNavigation': 'Navigationsmenü',
    'cache:title': 'Cache',
    'cache:description': 'Cache-Zustand und Ressourcenleistung auf dieser Replik.',
    'cache:load.error': 'Cache-Metriken konnten nicht geladen werden',
    'cache:load.retry': 'Erneut versuchen',
    'cache:reset.action': 'Metriken zurücksetzen',
    'cache:reset.loading': 'Cache-Metriken werden zurückgesetzt…',
    'cache:reset.success': 'Cache-Metriken zurückgesetzt',
    'cache:reset.error': 'Cache-Metriken konnten nicht zurückgesetzt werden',
    'cache:metric.hitRate': 'Trefferquote',
    'cache:metric.requests': 'Cache-Lesevorgänge',
    'cache:metric.avgCompute': 'Mittlere Berechnung',
    'cache:metric.errors': 'Fehler',
    'cache:unit.ms': '{value} ms',
    'cache:quarantine.title': 'Quarantänisierte Tags',
    'cache:quarantine.description': 'Diese Tags umgehen den Cache, bis die Invalidierung erfolgreich ist.',
    'cache:invalidate.title': 'Ressourcen-Cache invalidieren',
    'cache:invalidate.description': 'Listen- und Datensatzeinträge einer Ressource auf allen Repliken löschen.',
    'cache:invalidate.resource': 'Ressource',
    'cache:invalidate.action': 'Cache invalidieren',
    'cache:invalidate.loading': 'Cache wird invalidiert…',
    'cache:invalidate.success': 'Ressourcen-Cache invalidiert',
    'cache:invalidate.error': 'Ressourcen-Cache konnte nicht invalidiert werden',
    'cache:table.title': 'Metriken nach Namensraum',
    'cache:table.empty': 'Noch keine Cache-Aktivität erfasst.',
    'cache:instance': 'Replik {id}',
    'cache:table.namespace': 'Namensraum',
    'cache:table.resource': 'Ressource',
    'cache:table.hits': 'Treffer',
    'cache:table.misses': 'Fehltreffer',
    'cache:table.computes': 'Berechnungen',
    'cache:table.coalesced': 'Gebündelt',
    'cache:table.errors': 'Fehler',
  },
}
